module.exports = __webpack_public_path__ + "img/advantage5.aeb1b378.png";